// Autogenerated during build time. Do not modify.
export const RICOS_VERSION = '10.146.1';
